import { useEffect } from "react";

import { useLocation } from "react-router-dom";

function useBodyRouteClass() {
  const location = useLocation();

  useEffect(() => {
    // Normalize to a CSS-friendly class, e.g. route-earnings
    let routeClass = '';
    if (location.pathname.startsWith('/earnings')) routeClass = 'route-earnings';
    if (location.pathname.startsWith('/settings/general/wallet')) routeClass = 'route-wallet';


    // Remove previous
    document.body.classList.forEach(cls => {
      if (cls.startsWith('route-')) document.body.classList.remove(cls);
    });
    if (routeClass) document.body.classList.add(routeClass);

    return () => {
      if (routeClass) document.body.classList.remove(routeClass);
    };
  }, [location.pathname]);
}

export default useBodyRouteClass;